<div class="modal-header" id="upload-modal-title">
    <h3 class="modal-title" id="modal-title">{{ 'DOCBOX_UPLOAD_TITLE' | translate }}</h3>
</div>
<div class="modal-body">
    <form [formGroup]="formGroup">
        <div class="d-flex flex-column">
            <div class="upload-row row mb-sm-3 mb-2">
                <label class="col-sm-4 col-12 col-form-label text-start" for="file">{{
                    'DOCBOX_UPLOAD_FORM_FILE_SELECT' | translate
                }}</label>
                <div class="col-sm-8 col-12">
                    <pace-forms-file-upload
                        [allowedMimeTypes]="allowedMimeTypes"
                        id="file"
                        formControlName="file"
                    ></pace-forms-file-upload>
                    @if (
                        formGroup.controls['file'].invalid &&
                        (formGroup.controls['file'].dirty || formGroup.controls['file'].touched)
                    ) {
                        @if (formGroup.controls['file'].errors.forbiddenFileType) {
                            <div class="alert">
                                <span translate="DOCBOX_UPLOAD_FORM_FILE_SELECT_TYPE_ERROR"></span>
                                <br />
                                <ul>
                                    @for (mimetype of allowedMimeTypes; track mimetype) {
                                        <li>{{ mimetype }}</li>
                                    }
                                </ul>
                            </div>
                        }
                    }
                </div>
            </div>
            <div class="upload-row row mb-sm-3 mb-2">
                <label class="col-sm-4 col-12 col-form-label text-start" for="doctype">{{
                    'DOCBOX_UPLOAD_FORM_DOCTYPE' | translate
                }}</label>
                <div class="col d-flex">
                    <pace-forms-dropdown-options
                        id="doctype"
                        [options]="docTypeOptions"
                        [mandatory]="true"
                        formControlName="docType"
                        class="flex-grow-1"
                    ></pace-forms-dropdown-options>
                    <span
                        class="form-status-icon"
                        [ngClass]="
                            formGroup.get('docType')?.status === formControlInvalid ? 'invalid-status' : 'valid-status'
                        "
                    ></span>
                </div>
            </div>
            @if (formGroup.get('reportType')) {
                <div class="upload-row row mb-sm-3 mb-2">
                    <label class="col-sm-4 col-12 col-form-label text-start" for="reportType">{{
                        'DOCBOX_UPLOAD_FORM_REPORT_TYPE' | translate
                    }}</label>
                    <div class="col d-flex">
                        <pace-forms-dropdown-options
                            id="reportType"
                            [options]="reportTypeOptions"
                            [mandatory]="true"
                            formControlName="reportType"
                            class="flex-grow-1"
                        ></pace-forms-dropdown-options>
                        <span
                            class="form-status-icon"
                            [ngClass]="
                                formGroup.get('reportType')?.status === formControlInvalid
                                    ? 'invalid-status'
                                    : 'valid-status'
                            "
                        ></span>
                    </div>
                </div>
            }

            <div class="upload-row row mb-sm-3 mb-2">
                <label class="col-sm-4 col-12 col-form-label text-start" for="title">{{
                    'DOCBOX_UPLOAD_FORM_DOCUMENT_TITLE' | translate
                }}</label>
                <div class="col-sm-8 col-12 d-flex">
                    <input formControlName="title" id="title" type="text" class="form-control" />
                    <span
                        class="form-status-icon ps-3"
                        [ngClass]="
                            formGroup.get('title')?.status === formControlInvalid ? 'invalid-status' : 'valid-status'
                        "
                    ></span>
                </div>
            </div>

            <div class="upload-row row mb-sm-3 mb-2">
                <label class="col-sm-4 col-12 col-form-label text-start" for="date">{{
                    'DOCBOX_UPLOAD_FORM_DOCUMENT_DATE' | translate
                }}</label>
                <div class="col-sm-8 col-12 d-flex">
                    <input formControlName="date" id="date" type="date" class="form-control" />
                    <span
                        class="form-status-icon ps-3"
                        [ngClass]="
                            formGroup.get('date')?.status === formControlInvalid ? 'invalid-status' : 'valid-status'
                        "
                    ></span>
                </div>
            </div>

            <div class="upload-row row mb-sm-3 mb-2">
                <label class="col-sm-4 col-12 col-form-label text-start" for="ordernumber">{{
                    'DOCBOX_UPLOAD_FORM_DOCUMENT_ORDER_NUMBER' | translate
                }}</label>
                <div class="col-sm-8 col-12 d-flex">
                    <input formControlName="orderNumber" id="ordernumber" type="text" class="form-control" />
                    <span
                        class="form-status-icon ps-3"
                        [ngClass]="
                            formGroup.get('orderNumber')?.status === formControlInvalid
                                ? 'invalid-status'
                                : 'valid-status'
                        "
                    ></span>
                </div>
            </div>

            <div class="upload-row row mb-sm-3 mb-2">
                <label class="col-sm-4 col-12 col-form-label text-start" for="status">{{
                    'DOCBOX_UPLOAD_FORM_DOCUMENT_STATUS' | translate
                }}</label>
                <div class="col-sm-8 col-12 d-flex">
                    <pace-forms-dropdown-options
                        id="status"
                        [options]="reportStatusEnums"
                        [mandatory]="isStatusMandatory"
                        formControlName="reportStatus"
                        class="flex-grow-1"
                    ></pace-forms-dropdown-options>
                    <span
                        class="form-status-icon"
                        [ngClass]="
                            formGroup.get('reportStatus')?.status === formControlInvalid
                                ? 'invalid-status'
                                : 'valid-status'
                        "
                    ></span>
                </div>
            </div>

            <div class="upload-row row mb-sm-3 mb-2">
                <label class="col-sm-4 col-12 col-form-label text-start" for="protection">{{
                    'DOCBOX_UPLOAD_FORM_DOCUMENT_PROTECTION_CLASS' | translate
                }}</label>
                <div class="col-sm-8 col-12 d-flex">
                    <pace-forms-dropdown-options
                        id="protection"
                        [options]="protectionClasses"
                        [mandatory]="true"
                        formControlName="protectionClass"
                        class="flex-grow-1"
                    ></pace-forms-dropdown-options>
                    <span
                        class="form-status-icon"
                        [ngClass]="
                            formGroup.get('protectionClass')?.status === formControlInvalid
                                ? 'invalid-status'
                                : 'valid-status'
                        "
                    ></span>
                </div>
            </div>

            <div class="upload-row row mb-sm-3 mb-2">
                <div class="checkbox-container col-sm-4 col-2 ps-sm-5 pt-2">
                    <input formControlName="phiAgreement" id="phi_agreement" type="checkbox" #checkbox />
                    @if (checkbox.checked) {
                        <fa-icon [icon]="faCheck" size="2x"></fa-icon>
                    }
                </div>
                <div class="col-sm-8 col-10">
                    <label class="col-form-label text-start" for="phi_agreement"
                        >{{ 'DOCBOX_UPLOAD_FORM_DOCUMENT_PHI_AGREEMENT' | translate }}
                        <a
                            class="col-8 text-underline"
                            href="https://intranet.apps.siemens-healthineers.com/Med_TD/CS_Guidelines/guidelines/r2/ARTD/1e72201.pdf"
                            target="_blank"
                        >
                            {{ 'DOCBOX_UPLOAD_FORM_LINK_PHI' | translate }}</a
                        >
                    </label>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    @if (uploadPending) {
        <progressbar [value]="100" [striped]="true" [animate]="true" type="default"></progressbar>
    }
    @if (errorMessage.length > 0) {
        <span translate="DOCBOX_UPLOAD_ERROR_MESSAGE" class="error-message"></span>
        <span class="error-message">{{ errorMessage }}</span>
    }
    @if (showSuccessMessage) {
        <span translate="DOCBOX_UPLOAD_SUCCESS_MESSAGE" class="success-message"></span>
    }
    @if (!showSuccessMessage) {
        <button type="button" (click)="closeModal()" class="btn btn-secondary me-auto">
            {{ 'F4M_SUMMARY_MODAL_CANCEL_LABEL' | translate }}
        </button>
    }
    @if (!showSuccessMessage) {
        <button
            type="button"
            [disabled]="formGroup.invalid || uploadPending"
            class="btn btn-primary"
            (click)="upload()"
        >
            {{ 'DOCBOX_UPLOAD_FORM_DOCUMENT_UPLOAD' | translate }}
        </button>
    }
    @if (showSuccessMessage) {
        <button type="button" class="btn btn-primary" (click)="closeModal()">
            {{ 'DOCBOX_UPLOAD_CLOSE_MODAL' | translate }}
        </button>
    }
</div>
